import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-2, message, chat"} maskId="square-filled-radius-0-stroke-1-IconBubble2"><path d="M22.002 3V19H12.1304L6.50195 22.0956V19H2.00195V3H22.002Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubble2;
